<template>
    <div class="group_filter">
        <button class="group_item" :class="{'selected': isAllSelected}" @click="handleAllSelectButtonClick()">전체</button>
        <ReservationGroupFilterItem 
            v-for="(group, index) in groups" :key="index"
            :index="index"
            :group="group"
            @action_SelectItem="action_SelectItem" />
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { sheetFilters, setGroups, toggleGroup, toggleAllGroups, selectedGroups, storedGroups, removeStoredGroups } from '../../../sheet-filters'
import ReservationGroupFilterItem from './ReservationGroupFilterItem.vue'
import { useQueryClient } from '@tanstack/vue-query'
import store from '@/store'
import { useV2ReservationGroupListQuery } from '@/composables/queries/v2reservationgroup/use-v2-reservationgroup-find-query'
import { v2ReservationGroupFindRemovedQueryOptions } from '@/composables/queries/v2reservationgroup/use-v2-reservationgroup-find-removed-query'

export default {
    setup() {
        const queryClient = useQueryClient()
        // 선언형 구독 — FCM/뮤테이션 invalidation 시 자동 재조회된다 (수동 워처 불필요)
        const { data: fetchedGroups } = useV2ReservationGroupListQuery({
            hospitalID: () => store.state.hospital.selectedHospital?._id,
        })
        return { queryClient, fetchedGroups }
    },
    components: { ReservationGroupFilterItem },
    props: {
    },
    data() {
        return {
            sheetFilters,
        }
    },
    watch: {
        fetchedGroups: {
            immediate: true,
            handler: async function (groups) {
                if (!groups) { return }
                // 삭제된 그룹 반영(storedGroups 정합성) 후 목록 대입 — 기존 재조회 흐름과 동일 순서
                await this.requestFetchRemovedReservationGroups()
                // 컨트롤러 setter 가 입력 배열을 변형하므로 캐시 보호를 위해 복사본 전달
                setGroups(deepCopy(groups))
            }
        }
    },
    computed: {
        groups: function() {
            let groups = deepCopy(this.sheetFilters.groups)
            return groups.sort( (l, r) => { return l.order - r.order } )
        },
        selectedGroups: function() {
            return selectedGroups()
        },
        isAllSelected: function() {
            return this.selectedGroups.length == this.groups.length
        }
    },
    methods: {
        handleAllSelectButtonClick() {
            toggleAllGroups(!this.isAllSelected)
        },
        action_SelectItem(group) {
            let target = this.sheetFilters.groups.find(g => g._id == group._id)
            let index = this.sheetFilters.groups.indexOf(target)
            toggleGroup(index)
        },

        // MARK : Network
        async requestFetchRemovedReservationGroups() {
            try {
                let currentGroupIDs = storedGroups().map(g => g._id)
                if (currentGroupIDs.length == 0) { return }
                let param = {
                    hospitalID: this.hospital.selectedHospital._id,
                    groupID: currentGroupIDs,
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                const removedGroupIDs = await this.queryClient.fetchQuery(v2ReservationGroupFindRemovedQueryOptions(param))
                removeStoredGroups(removedGroupIDs)
            } catch(err) {
                console.log('removed reservation group check error : ', err)
            }
        }
    }
}
</script>